




































/* eslint-disable @typescript-eslint/no-explicit-any */
import { getMessageById } from '@/utils/message';
import { convertStr2Num } from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlNensan',
  props: {
    label: { required: false, type: String, default: '' },
    required: { required: false, type: Boolean, default: false },
    value: { required: false, type: [String, Number], default: '' },
    textAlign: { required: false, type: String, default: 'right' },
    isNoData: { required: false, default: false },
  },

  data() {
    return {
      textValue: '',
      rules: {
        required: (value: string) => !!value || getMessageById('KI_W007'),
        noData: null,
      },
      isOutFocus: false,
      style: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    };
  },

  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),

    inputRules() {
      if (this.required && this.isNoData && this.isOutFocus) {
        return [this.rules.required, this.rules.noData];
      } else if (this.required || (this.required && !this.isNoData)) {
        return [this.rules.required];
      } else if (!this.textValue) {
        return [];
      } else if (this.isNoData && this.isOutFocus) {
        return [this.rules.noData];
      } else {
        return [];
      }
    },

    textColor() {
      return convertStr2Num(this.textValue) < 0 ? 'text-red' : '';
    },
    readonly() {
      return (
        'readonly' in this.$attrs &&
        (this.$attrs.readonly === '' ||
          this.$attrs.readonly === 'true' ||
          this.$attrs.readonly)
      );
    },
  },

  methods: {
    format(value: any) {
      let formatValue = '';
      if (value.length === 2 && (/^\d*$/).test(value)) {
        // 2桁の場合は4桁にフォーマット
        const genzaiYmd = this.userInfo.onlineData.genzaiYmd;
        const century = `${genzaiYmd}`.substring(0, 2);
        formatValue = `${century}${value}`;
      } else if (value.length === 4 && (/^([1-9]\d*|0)$/).test(value)) {
        formatValue = Number(value) >= 1900 ? value : '';
      }
      return formatValue;
    },
    // 入力値を変更時、フォーマットする
    onBlur(event: any) {
      this.isOutFocus = true;
      if (this.readonly) {
        return;
      }
      const value = event.target.value;
      let formatValue = this.format(value);
      const self = this;
      this.$nextTick(() => {
        self.textValue = formatValue;
        self.$emit('input', +formatValue);
      });
    },
    onFocus(focusEvent: any) {
      this.isOutFocus = false;
      // High prioty
      if (this.readonly) {
        return;
      }
      this.$nextTick(function () {
        focusEvent.target.select();
      });
    },
    defaultValue() {
      return this.value;
    },
  },
  watch: {
    value(newVal) {
      let formatValue = this.format((newVal || 0).toString());
      let realValue = formatValue.replaceAll(',', '');
      this.textValue = realValue;
    },
    isNoData(newVal) {
      if (newVal) {
        this.rules.noData = '';
      } else {
        this.rules.noData = true;
      }
    },
  },
  mounted() {
    // テキスト値を変更時、フォーマットする
    this.textValue = this.format(this.defaultValue().toString());
    this.$emit('input', +this.textValue);
  },
});
